import EcommerceMetrics from "../../components/ecommerce/EcommerceMetrics";
import MonthlySalesChart from "../../components/ecommerce/MonthlySalesChart";
import StatisticsChart from "../../components/ecommerce/StatisticsChart";
import MonthlyTarget from "../../components/ecommerce/MonthlyTarget";
import RecentTransactions from "../../components/ecommerce/RecentTransactions";
import DemographicCard from "../../components/ecommerce/DemographicCard";
import PageMeta from "../../components/common/PageMeta";

export default function Ecommerce() {
  return (
    <>
      <PageMeta
        title="Chit Fund Management System"
        description="Chit Fund Management system"
      />
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-12 space-y-6 xl:col-span-7">
          <EcommerceMetrics />

          <MonthlySalesChart />
        </div>

        <div className="col-span-12 xl:col-span-5">
          <MonthlyTarget />
        </div>

        {/*<div className="col-span-12">
          <StatisticsChart />
        </div>*/}

        {/*<div className="col-span-12 xl:col-span-12">
          <DemographicCard />
        </div>*/}

        <div className="col-span-12 xl:col-span-12">
          <RecentTransactions />
        </div>
      </div>
    </>
  );
}
